import { render } from "./AuthDataCard.vue?vue&type=template&id=31c0003a"
import script from "./AuthDataCard.vue?vue&type=script&lang=js"
export * from "./AuthDataCard.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__